import React, { useState, useEffect } from 'react';
import { operatorDataSelector } from '../OperatorPage/redux/selectors';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import FAQ from '../CommonResp/FAQ/FAQ';
import Footer from '../CommonResp/Footer/Footer';
import { redirectToFunnel } from '../Common/utils/redirectToFunnel';
import Tile from '../CommonResp/Tile/Tile'
import Heading from '../CommonResp/Heading/Heading';
import Breadcrumbs from '../CommonResp/BreadcrumbsWithoutSchema/Breadcrumbs';
import { isMobileView } from '../Common/utils';
import getDateObj from './../Common/utils/GetDateObj';
import dateformat from 'dateformat';
import Carousel from '../CommonResp/Carousel/Carousel';
import OperatorListing from './OperatorListing/OperatorListing';
import ImagesGallery from './ImagesGallery/ImagesGallery';
import Amenities from './Amenities/Amenities';
import MobileHeader from '../CommonResp/MobileHeader/MobileHeader';
import TemplateContent from '../CommonResp/Content/Content';
import { getBreadCrumbObj } from '../CommonResp/utils';
import GeneralContentBlock from './../CommonResp/GeneralContentBlock/GeneralContentBlock';
import OperatorTypeListing from "../OperatorTypeRespPage/OperatorTypeListing/OperatorTypeListing";
import { OtherBusServicesView, getOperatorView, getPointsView, getOtherOperatorView } from "./BusTiles";
import SeoContainerHeader from "../Common/SeoContainerHeader";
import PageNotFound from '../CommonResp/PageNotFoud/PageNotFound';
import AdBanner from './../../components/AdBanner/AdBanner';
import CrossTemplate from '../CommonResp/CrossTemplate/CrossTemplateTile';
import CancellationPolicyBlock from '../CommonResp/CancellationPolicy/CancellationPolicyBlock';
import { calculateDaysToTrip, ctaHelper, CTA_TYPE, getDate, sendPageViewEvent, trackActionEvent } from '../../utils/Omniture';
import { PAGE_NAMES } from '../config/constants';
import { routeDataSelector } from '../RoutePage/redux/selectors';


const OperatorRespPage = (props) => {
    const [showClientContent, enableClient] = useState(false);
    const [showAllBuses, setShowAllBuses] = useState(false);
    const { busTypePage = false } = props;
    const mobileView = isMobileView();
    const data_date = dateformat(getDateObj(), 'yyyymmdd');
    const data = useSelector(routeDataSelector);
    useEffect(() => {
        enableClient(true);
    }, []);
    useEffect(()=>{
        let pageName = ''
        if(props?.busTypePage){
            pageName = PAGE_NAMES.rtc_service
        }else{
            pageName =  PAGE_NAMES.operator
        }
        const eventDetails = {
         pageName:  pageName
        }
        sendPageViewEvent(eventDetails)
   },[]);
    const operatorStoreData = useSelector(operatorDataSelector);
    const {
        route_buses = [],
        bus_amenities = [],
        bus_photos,
        bus_reviews,
        top_bus_route_op,
        bus_types,
        other_operators,
        canonical_url,
        seo_meta = {},
        template,
        offers,
        footer_links,
        operatorName,
        operatorId,
        src_dump,
        cross_template_links = {},
        dummy_data,
        general_content,
        general_contents = [],
        basic_info = {},
        bus_routes = [],
        other_bus_services = [],
        titles = {},
        notToCrawl = false,
        cancellation_policy = {},
        date,
        notToIndex=false
    } = operatorStoreData;
    const bus_routes_title = titles?.bus_routes
    const bus_amenities_title = titles?.bus_amenities
    const bus_photos_title = titles?.bus_photos
    const otherBusServicesTitle = titles?.other_bus_services

    const { content = "", faq = {}, contents = [] } = template || {};
    const { title, info } = basic_info;
    const { view: bus_types_content, isDataPresent: is_bus_type_content_present } = getPointsView(bus_types)
    const { view: topOperatorView, isDataPresent: isTopOperatorDataPresent } = getOperatorView(top_bus_route_op)
    const { view: otherBusServicesView, isDataPresent: isOtherBusServices } = OtherBusServicesView(other_bus_services)
    const { view: other_operators_content, isDataPresent: is_other_operators_content_present } = getOtherOperatorView(other_operators)

    const dummyDataView = dummy_data && !route_buses.length;
    const renderOfferCarousel = showClientContent && offers && offers.length ? true : false;
    const { dest_state_name='', src_state_name = '' } = data;


    const moveToFunnel = (params, eventName = 'viewBuses', track = true) => {
      let cta_data =  eventName == 'busUpdateSearch' 
       ?  ['Update_Search', CTA_TYPE.BUTTON, 'Header', 'SRP']
       : ['VIEW BUSES', CTA_TYPE.BUTTON, 'Body', 'SRP']
        const eventDetails = {
            cta: ctaHelper(cta_data),
            booking: {
                routeCity: '',
                routeState: `${src_state_name}-${dest_state_name}`,
                daysToTrip: date ? calculateDaysToTrip(getDate(date)) : '',
                departureDate: date ? date : '',
            }
        };
        if (track) {
            trackActionEvent(eventName, eventDetails, { gloabl: true });
        }

        redirect(params);
    }

    const redirect = (params) => {
     redirectToFunnel({ ...params, data_date })
    }

    const adTechId = (() => {
        return "QlVTI09QRVJBVE9SIFNFTyNWSUVXIE1PUkUgQlVTRVM=";
    })();

    const { h1_title = "", meta_title = "", meta_description = "", meta_keywords = "", breadcrumb = "" } = seo_meta;

    const breadCrumbObj = getBreadCrumbObj(breadcrumb, canonical_url);

    return (
        <>
            <div className="seoContainer">
                {notToCrawl ? <></> :
                    <div className="desktopOnly">
                        <SeoContainerHeader
                            date={data_date}
                            onUpdateSearch={moveToFunnel}
                        />
                    </div>
                }
                <Helmet
                    title={meta_title}
                    meta={
                        [{ name: 'description', content: meta_description },
                        { name: 'keywords', content: meta_keywords },
                        { property: 'og:title', content: meta_title },
                        { property: 'og:description', content: meta_description },
                        { property: 'og:image', content: 'https://gos3.ibcdn.com/bus-default-1489655303.jpg' },
                        { property: 'og:url', content: canonical_url },
                        notToCrawl  ? { name: 'robots', content: 'noindex,nofollow' } : '',
                        notToIndex  ? { name: 'robots', content: 'noindex' } : '',
                    ]
                        
                    }
                    link={[{
                        href: canonical_url,
                        rel: 'canonical',
                    },]}
                />
                {notToCrawl ?
                    <PageNotFound src={""}
                        dest={""}
                        src_id={""}
                        dest_id={""}
                        date={""}
                        onUpdateSearch={() => moveToFunnel({}, 'busUpdateSearch')}
                        showHeaderOnly={notToCrawl}
                        footer_links={footer_links}
                    ></PageNotFound>
                    : <>
                        <Helmet>
                            <script type="application/ld+json">{`${JSON.stringify(breadCrumbObj)}`}</script>
                        </Helmet>
                        {showClientContent ?
                            <MobileHeader
                                title={h1_title}
                                date={data_date}
                                moveToFunnel={moveToFunnel} />
                            : <></>}
                        <div className="ContentWrapper">
                            <div className="contentSection operatorsContentScetion">
                                <div className="RgtSection">
                                    <Heading content={h1_title}></Heading>
                                    <Breadcrumbs content={breadcrumb}></Breadcrumbs>
                                    <TemplateContent data={general_contents} className="seoDescTitle"></TemplateContent>
                                </div>
                                <div className="LftSection">
                                    {renderOfferCarousel && !mobileView ?
                                        <Carousel content={offers} count={isMobileView() ? offers.length : 1}
                                            lazyload={false}></Carousel> : null}
                                </div>
                            </div>

                            {!dummyDataView ?
                                <p className="listingHeading">
                                    {`${bus_routes_title ? bus_routes_title : `Top Routes for ${operatorName}`}`}
                                </p>
                                :
                                <>
                                    {/* <NoBusFound /> */}
                                </>
                            }

                            {bus_routes && bus_routes.length && props.busTypePage ?
                                <OperatorTypeListing
                                    content={bus_routes}
                                    src_dump={src_dump}
                                    showAllBuses={showAllBuses}
                                    moveToFunnel={moveToFunnel}
                                    showClientContent={showClientContent}
                                /> :
                                route_buses && route_buses.length ?
                                    <OperatorListing
                                        content={route_buses}
                                        src_dump={src_dump}
                                        showAllBuses={showAllBuses}
                                        moveToFunnel={moveToFunnel}
                                        showClientContent={showClientContent}
                                        operatorName={operatorName}
                                        operatorId={operatorId}
                                    /> : <></>}

                            {showClientContent && !showAllBuses && !dummyDataView ?
                                <div
                                    className="viewMoreBuses moreBtn cpointer"
                                    title="View More Routes"
                                    onClick={() => { setShowAllBuses(true) }}>
                                    VIEW MORE BUSES
                                </div> : <></>}

                            {showAllBuses ? <div className="appendBottom24" /> : <></>}

                            {showClientContent ? <AdBanner cid={adTechId} /> : <></>}

                            <CancellationPolicyBlock cancellation_policy={cancellation_policy} />
                            <GeneralContentBlock data={info} title={title} />
                            <TemplateContent className="whiteCard" data={contents} content={content}></TemplateContent>

                            {showClientContent && bus_amenities && bus_amenities.length ?
                                <div className="whiteCard whiteCardOperators">
                                    <h2>Bus Amenities</h2>
                                    <Amenities
                                        content={bus_amenities}
                                        heading={bus_amenities_title ? bus_amenities_title : "Bus Amenities"}
                                        count={mobileView ? bus_amenities.length : 14} />
                                </div>
                                : <></>}

                            {showClientContent && bus_photos && bus_photos.length ?
                                <div className="whiteCard whiteCardOperators">
                                    <h2>Bus Photos</h2>
                                    <ImagesGallery
                                        content={bus_photos}
                                        heading={bus_photos_title ? bus_photos_title : "Bus Photos"}
                                        count={mobileView ? bus_photos.length : 5} />
                                </div>
                                : null}
                            {/* {false ? <DiscTitle content={content} className="whiteCard" /> : null} */}

                            <FAQ data={faq}></FAQ>

                            <div className="whiteCardWrapper">
                                {isOtherBusServices && props.busTypePage ?
                                    <Tile
                                        tileContent={otherBusServicesView} tileHeading={otherBusServicesTitle}
                                        isTileContent={isOtherBusServices}
                                        parentClassName="whiteCard sectionInfoOperator"
                                        childClassName="cardInfoContent" /> :
                                    bus_types && bus_types.length ?
                                        <Tile
                                            tileContent={bus_types_content} tileHeading={`Bus Type`}
                                            isTileContent={is_bus_type_content_present}
                                            parentClassName="whiteCard sectionInfoOperator"
                                            childClassName="cardInfoContent" /> :
                                        null}
                                {top_bus_route_op && top_bus_route_op.length ?
                                    <Tile tileContent={topOperatorView} tileHeading={`Popular Operator Routes`}
                                        isTileContent={isTopOperatorDataPresent}
                                        parentClassName="whiteCard sectionInfoOperator"
                                        childClassName="cardInfoContent"></Tile> : null}
                                {other_operators && other_operators.length ?
                                    <Tile tileContent={other_operators_content} tileHeading={`More Bus Operators`}
                                        isTileContent={is_other_operators_content_present}
                                        parentClassName="whiteCard sectionInfoOperator"
                                        childClassName="cardInfoContent"></Tile> : null}
                            </div>

                            <div className="whiteCardWrapper">
                                <CrossTemplate cross_template_links={cross_template_links} />
                            </div>
                        </div>
                        <Footer data={footer_links}></Footer>
                    </>
                }
            </div>
        </>
    )
}

export default OperatorRespPage;
